import React, { Component } from 'react'
import PopupWindow from './PopupWindow'
import { connect } from 'react-redux';
import * as StatisticActions from '../../actions/statisticActions';
import { bindActionCreators } from 'redux';
import Checkbox from './Checkbox'
import StatsBaseWindow from './StatsBaseWindow'

class LatestScoresWindow extends StatsBaseWindow {

    static propTypes = {
        top: React.PropTypes.number,
        left: React.PropTypes.number
    }

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        top: 10,
        left: 10
    }

    onResize(width, height) {

    }

    render() {
        const { close_stats_window } = this.props.StatisticActions;
        
        return (<PopupWindow header="Последние результаты" resizable={true} width={this.props.width} height={this.props.height} onResizeStop={this.onResizeStop.bind(this)} onResize={this.onResize.bind(this)} is_cut_down={this.props.is_cut_down} onDragStop={this.onDragStop.bind(this)} onToggleCutDown={this.onToggleCutDown.bind(this)} top={this.position.top}  left={this.position.left} onClose={() => (close_stats_window(this.props.id))}>
                    {this.props.games.length == 0 ? (
                        <div className="latestscores">Нет матчей</div>
                    ) : (
                    <div className="latestscores">
                        {this.props.games.map((game, i) =>
                            <div className="game">
                                <div key={i+'game'} className="row header">
                                    <div className="col-md-5 col-sm-5 rightAlign">
                                        <div className={this.props.theme == 0 ? "col-md-10 col-sm-10" : "col-md-12 col-sm-12"}>
                                            {game.team1}
                                        </div>
                                        {
                                            this.props.theme == 0 &&
                                                <div className="col-md-2 col-sm-2 logo">
                                                    <img src={'https://pefl.ru/' + game.logo1}></img>
                                                </div>
                                        }
                                    </div>
                                    <div className="col-md-2 col-sm-2 centerAlign">{game.score.home}:{game.score.away}</div>
                                    <div className="col-md-5 col-sm-5 leftAlign">
                                        {
                                            this.props.theme == 0 &&
                                                <div className="col-md-2 col-sm-2 logo">
                                                    <img src={'https://pefl.ru/' + game.logo2}></img>
                                                </div>
                                        }
                                        <div className={this.props.theme == 0 ? "col-md-10 col-sm-10" : "col-md-12 col-sm-12"}>
                                            {game.team2}
                                        </div>
                                    </div>
                                </div>
                                <div key={i+'goals'} className="row goals">
                                    <div className="col-md-5 col-sm-5 rightAlign">
                                        {game.goals1.map((goal, i) =>
                                            <div key={'goal'+i} className="row">{goal.player} {goal.min}</div> 
                                        )}
                                    </div>
                                    <div className="col-md-2 col-sm-2"></div>
                                    <div className="col-md-5 col-sm-5 leftAlign">
                                        {game.goals2.map((goal, i) =>
                                            <div key={'goal'+i} className="row">{goal.player} {goal.min}</div> 
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    )}
                </PopupWindow>)
    }
}

function mapStateToProps(state, ownProps) {
    let width = state.statisticWindows[ownProps.id].width;
    let height = state.statisticWindows[ownProps.id].height;

    width = width == null || width == NaN ? 400 : width;
    height = height == null || height == NaN ? 300 : height;
    
    return {
        position: state.statisticWindows.latestScores.position,
        is_cut_down: state.statisticWindows.latestScores.is_cut_down,
        games: state.online_games.games,
        height: height,
        width: width,
        theme: state.theme
    };
}

function mapDispatchToProps(dispatch) {
    return {
        StatisticActions: bindActionCreators(StatisticActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LatestScoresWindow)



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/LatestScoresWindow.js
 **/